"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// do to the backend sending non-supported products in an undesirably ordered fashion
// we have to do the filtering and sorting on the front end
var filterSortSupportedProducts = function filterSortSupportedProducts(itemsArray) {
  if (!_config["default"].global.products || _config["default"].global.products.length === 0) {
    return itemsArray;
  }
  var filteredSortedProducts = [];
  _config["default"].global.products.forEach(function (symbol) {
    var product = itemsArray.find(function (item) {
      return item.Product === symbol || item.ProductSymbol === symbol;
    });
    if (product) {
      filteredSortedProducts.push(product);
    }
  });
  return filteredSortedProducts;
};
var _default = exports["default"] = filterSortSupportedProducts;